import { plainToInstance } from 'class-transformer'

import {
  GetTicketDetailPathVar,
  GetTicketDetailResDto,
  GetUserInputTemplatePathVar,
  GetUserInputTemplateResDto
} from '@/api/dto/ticket'
import axios from '@/lib/axiosClient'

/**
 * 주차권상세
 * @pathVar {couponSeq: number}
 * @result {GetTicketDetailResDto}
 */
const getTicketDetail = async (pathVar: GetTicketDetailPathVar): Promise<GetTicketDetailResDto> => {
  const { data } = await axios.get<GetTicketDetailResDto>(`/ticket/${pathVar.couponSeq}`)
  return plainToInstance(GetTicketDetailResDto, data)
}

/**
 * 주차권이용자정보 템플릿
 * @pathVar {couponSeq: number}
 * @result {GetUserInputTemplateResDto}
 */
const getUserInputTemplate = async (pathVar: GetUserInputTemplatePathVar): Promise<GetUserInputTemplateResDto> => {
  const { data } = await axios.get<GetUserInputTemplateResDto>(`/ticket/${pathVar.couponSeq}/user-input-template`)
  return plainToInstance(GetUserInputTemplateResDto, data)
}

const ticketApi = {
  getTicketDetail,
  getUserInputTemplate
}

export default ticketApi
